import { action } from "typesafe-actions";
import { ILawyeredChallan } from "./lawyered.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import { showMessage } from "../messages/messagesActions";
import { endPoints } from "../../constants/endPoints";
import { ISearchQueryParams } from "../common/common.types";

// ==================== LAWYERED CHALLAN ACTIONS ====================

// Fetch Lawyered Challan List Actions
export const FETCH_LAWYERED_CHALLAN_LIST_PROGRESS = "FETCH_LAWYERED_CHALLAN_LIST_PROGRESS";
export const FETCH_LAWYERED_CHALLAN_LIST_SUCCESS = "FETCH_LAWYERED_CHALLAN_LIST_SUCCESS";
export const FETCH_LAWYERED_CHALLAN_LIST_FAILED = "FETCH_LAWYERED_CHALLAN_LIST_FAILED";
export const CLEAR_LAWYERED_CHALLAN_LIST_STATE = "CLEAR_LAWYERED_CHALLAN_LIST_STATE";

export const fetchLawyeredChallanListProgress = () => action(FETCH_LAWYERED_CHALLAN_LIST_PROGRESS);
export const fetchLawyeredChallanListSuccess = (list: ILawyeredChallan[], totalRecords: number) =>
  action(FETCH_LAWYERED_CHALLAN_LIST_SUCCESS, { list, totalRecords });
export const fetchLawyeredChallanListFailed = () => action(FETCH_LAWYERED_CHALLAN_LIST_FAILED);
export const clearLawyeredChallanListState = () => action(CLEAR_LAWYERED_CHALLAN_LIST_STATE);

// Fetch Single Lawyered Challan Actions
export const FETCH_LAWYERED_CHALLAN_PROGRESS = "FETCH_LAWYERED_CHALLAN_PROGRESS";
export const FETCH_LAWYERED_CHALLAN_SUCCESS = "FETCH_LAWYERED_CHALLAN_SUCCESS";
export const FETCH_LAWYERED_CHALLAN_FAILED = "FETCH_LAWYERED_CHALLAN_FAILED";
export const CLEAR_LAWYERED_CHALLAN = "CLEAR_LAWYERED_CHALLAN";

export const fetchLawyeredChallanProgress = () => action(FETCH_LAWYERED_CHALLAN_PROGRESS);
export const fetchLawyeredChallanSuccess = (challan: ILawyeredChallan) =>
  action(FETCH_LAWYERED_CHALLAN_SUCCESS, { challan });
export const fetchLawyeredChallanFailed = (errorMessage: string) =>
  action(FETCH_LAWYERED_CHALLAN_FAILED, { errorMessage });
export const clearLawyeredChallan = () => action(CLEAR_LAWYERED_CHALLAN);

export const fetchLawyeredChallanListAsync =
  (
    queryParams: ISearchQueryParams | any,
    onCallback?: (isSuccess: boolean, data?: ILawyeredChallan[], totalRecords?: number) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(fetchLawyeredChallanListProgress());

      const {
        page = 1,
        rowsPerPage = 25,
        status,
        date,
        payment_done,
      } = (queryParams || {}) as any;

      let finalUrl = `${endPoints.lawyered.getLawyeredChallan}?pageNo=${page}&itemPerPage=${rowsPerPage}`;

      if (date && date.fromDate && date.toDate) {
        finalUrl += `&from_date=${date.fromDate}&to_date=${date.toDate}`;
      }

      if (status && status !== "-1") {
        finalUrl += `&status=${status}`;
      }

      if (payment_done !== undefined && payment_done !== null && payment_done !== "-1") {
        finalUrl += `&payment_done=${payment_done}`;
      }

      const res = await api.get(finalUrl);
      const data: ILawyeredChallan[] = res?.data?.data || [];
      const totalRecords = res?.data?.totalRecords ?? res?.data?.total_records ?? 0;

      dispatch(fetchLawyeredChallanListSuccess(data, totalRecords));
      if (onCallback) {
        onCallback(true, data, totalRecords);
      }
    } catch (err: any) {
      dispatch(fetchLawyeredChallanListFailed());
      dispatch(
        showMessage({
          message: err?.response?.data?.message || "Failed to fetch Lawyered Challan list",
          type: "error",
          displayAs: "snackbar",
        })
      );
      if (onCallback) {
        onCallback(false);
      }
    }
  };

export const fetchLawyeredChallanAsync =
  (
    lawyeredChallanUuid: string,
    onCallback?: (isSuccess: boolean, data?: ILawyeredChallan) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(fetchLawyeredChallanProgress());
      const res = await api.get(`${endPoints.lawyered.getLawyeredChallan}?lawyered_challan_uuid=${lawyeredChallanUuid}`);
      const data: ILawyeredChallan = Array.isArray(res.data?.data) ? res.data.data[0] : res.data?.data;
      dispatch(fetchLawyeredChallanSuccess(data));
      if (onCallback) {
        onCallback(true, data);
      }
    } catch (err: any) {
      const errorMsg = err?.response?.data?.message || "Failed to fetch Lawyered Challan details";
      dispatch(fetchLawyeredChallanFailed(errorMsg));
      dispatch(
        showMessage({
          message: errorMsg,
          type: "error",
          displayAs: "snackbar",
        })
      );
      if (onCallback) {
        onCallback(false);
      }
    }
  };
